module.exports = __webpack_public_path__ + "img/MC.488ad10f.svg";